import * as type from '@app/constants/scenes/createScene'

export const addScene = () => ({
  type: type.ADD_SCENE,
} as const)
